<template>
  <header
    class="fixed w-full backdrop-blur-md z-50"
    :class="temaA2 ? 'a2-tema header-tema' : 'bg-white/95 border-b border-gray-100 shadow-sm'"
  >
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center h-16">
        <Logo />
        <Navigation class="hidden md:flex" :current-path="route.path" />
        <div class="flex items-center gap-3">
          <div v-if="temaA2" class="hidden md:flex items-center gap-3">
            <LanguageSelector />
            <ThemeToggle />
          </div>
          <AuthButtons class="hidden md:flex" />
          <MobileMenuButton
            :is-open="isMenuOpen"
            @toggle="isMenuOpen = !isMenuOpen"
            class="md:hidden"
          />
        </div>
      </div>
    </div>

    <!-- Fora do cabeçalho: o desfoque dele prenderia o painel fixo à altura do cabeçalho -->
    <Teleport to="body">
      <Transition name="menu-celular">
        <MobileMenu
          v-if="isMenuOpen"
          @close="isMenuOpen = false"
          :current-path="route.path"
        />
      </Transition>
    </Teleport>
  </header>
</template>

<script setup lang="ts">
import { ref, computed, watch, watchEffect } from 'vue'
import { useRoute } from 'vue-router'
import Logo from './header/Logo.vue'
import Navigation from './header/Navigation.vue'
import AuthButtons from './header/AuthButtons.vue'
import MobileMenuButton from './header/MobileMenuButton.vue'
import MobileMenu from './header/MobileMenu.vue'
import ThemeToggle from './header/ThemeToggle.vue'
import LanguageSelector from './header/LanguageSelector.vue'
import { IDIOMAS, ROTAS_VISUAL_NOVO, useIdioma } from '../i18n/idioma'

const route = useRoute()
const isMenuOpen = ref(false)
// Voltar ou trocar de página fecha o menu do celular
watch(() => route.fullPath, () => { isMenuOpen.value = false })

// Páginas no visual do A2: o cabeçalho acompanha o tema e o idioma delas
const temaA2 = computed(() => ROTAS_VISUAL_NOVO.includes(route.path))

const { idioma } = useIdioma()
watchEffect(() => {
  document.documentElement.lang = IDIOMAS.find(i => i.codigo === idioma.value)?.lang ?? 'pt-BR'
})
</script>

<style>
.menu-celular-enter-active, .menu-celular-leave-active { transition: opacity 0.25s ease, transform 0.3s cubic-bezier(0.2, 0.7, 0.2, 1); }
.menu-celular-enter-from, .menu-celular-leave-to { opacity: 0; transform: translateY(-12px); }

.logo-claro { display: none; }

.header-tema {
  background: color-mix(in srgb, var(--a2-bg) 82%, transparent);
  border-bottom: 1px solid var(--a2-line);
}

.header-tema nav a { color: var(--a2-muted); background: transparent; }
.header-tema nav a:hover { color: var(--a2-ink); background: var(--a2-card); }
.header-tema nav a.text-green-600 { color: var(--a2-signal); background: var(--a2-card); }

.header-tema a.text-gray-600 { color: var(--a2-muted); }
.header-tema a.text-gray-600:hover { color: var(--a2-ink); }

.header-tema button.bg-gradient-to-r {
  background: var(--a2-signal);
  color: var(--a2-signal-ink);
  box-shadow: 0 10px 30px -12px rgba(61, 255, 168, 0.55);
}

.header-tema .md\:hidden.bg-white { background: var(--a2-bg); border-color: var(--a2-line); }
.header-tema .md\:hidden a.text-gray-700 { color: var(--a2-ink); }
.header-tema .md\:hidden a.text-gray-700:hover { background: var(--a2-card); }
.header-tema .md\:hidden .border-gray-100 { border-color: var(--a2-line); }
.header-tema button.md\:hidden, .header-tema button.md\:hidden * { color: var(--a2-ink); }

/* Logo com nome claro só no tema escuro */
.header-tema .logo-padrao { display: none; }
.header-tema .logo-claro { display: block; }

@media (prefers-color-scheme: light) {
  :root:not([data-theme="dark"]) .header-tema .logo-padrao { display: block; }
  :root:not([data-theme="dark"]) .header-tema .logo-claro { display: none; }
}

:root[data-theme="light"] .header-tema .logo-padrao { display: block; }
:root[data-theme="light"] .header-tema .logo-claro { display: none; }
</style>
